import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const root = css`
  inline-size: 100%;
`
export const item = css`
  box-sizing: border-box;
  padding: ${spacing(2, 0.5)};
  inline-size: 100%;
  background-color: ${cssTheme.default.day.background};
  box-shadow: 0 0 0;
  transition: box-shadow ease 0.2s;
`
export const justifyEnd = css`
  margin-inline-start: auto;
  justify-self: flex-end;
`
export const icon = css`
  font-size: 14px;
  margin-inline-end: ${spacing(1)};
  inline-size: ${spacing(2.5)};
  block-size: ${spacing(2.5)};
  line-height: ${spacing(2.5)};
  border-radius: 50%;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
  background-color: #5c5a57;
  margin-inline-start: ${spacing(1)};
`
export const dividerBottom = css`
  border-block-end: 1px solid ${cssTheme.default.day.line};
`
export const iconRed = css`
  background-color: #f5523a;
`
export const fullWidth = css`
  inline-size: 100%;

  & > div {
    inline-size: 100%;
  }
`
